// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2gO7d","tab":"Tabs_tab__2YbDc","tabActive":"Tabs_tabActive__1gBT7"};